import { render } from "./partial-command-action-force-dialog.vue?vue&type=template&id=20825153&ts=true"
import script from "./partial-command-action-force-dialog.vue?vue&type=script&lang=ts"
export * from "./partial-command-action-force-dialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__